import React, { Component } from "react";
import _ from "lodash";

export class BaseComponent2 extends Component {
  validateEmail = ({ get, value, fieldProps, fields, form }) => {
 
    var re = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,10})+$/;
    let check = re.test(value);
    return check;
  };

  validateDaysNumber = ({ get, value, fieldProps, fields, form }) => {

    var re = /^\d+$/;
    let check = re.test(value);
    return check;
  };

  validateIntNumber = ({ get, value, fieldProps, fields, form }) => {
  
    var re = /^\d+$/;
    let check = re.test(value);
    return check;
  };

  validateOnlyNumber = ({ get, value, fieldProps, fields, form }) => {

    let check = !isNaN(value);
    return check;
  };

  validatePhoneNumber = ({ get, value, fieldProps, fields, form }) => {
    // let re = /^\+(9[976]\d|8[987530]\d|6[987]\d|5[90]\d|42\d|3[875]\d|2[98654321]\d|9[8543210]|8[6421]|6[6543210]|5[87654321]|4[987654310]|3[9643210]|2[70]|7|1)\W*\d\W*\d\W*\d\W*\d\W*\d\W*\d\W*\d\W*\d\W*(\d{1,2})$/
    let re = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;

    // let check = !isNaN(value) && value.length === 10;
    // let check =  value.match(re);
    let check = re.test(value);
    return check;
  };

  validateOnlyText = ({ get, value, fieldProps, fields, form }) => {
    let check = /^[a-zA-Z0-9- ]*$/.test(value);
    return check;
  };

  validateSelectBoxRequired = ({ get, value, fieldProps, fields, form }) => {
    let check = value != "";
    return check;
  };
  validateWebsite = ({ get, value, fieldProps, fields, form }) => {
    if (value != "") {
      let re = /^(?:(ftp|http|https):\/\/)?(?:[\w-]+\.)+[a-z]{2,6}$/;
      let check = re.test(value);

      return check;
    }
  };
  validateAlphaNumeric = ({ get, value, fieldProps, fields, form }) => {
    let re = /^[a-z0-9]+$/i;
    let check = re.test(value);
    return check;
  };

  validateTime = ({ get, value, fieldProps, fields, form }) => {
    if (value != "") {
      let re = /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/i;
      let check = re.test(value);
      return check;
    }
  };

  validateTopic = ({ get, value, fieldProps, fields, form }) => {
    //let re = /^\/\w+\/\w+\/$/;
    let re = /^\w+\/\w+$/g;
    let check = re.test(value);
    return check;
  };

  validateSpecialChars = ({ get, value, fieldProps, fields, form }) => {
    var regex = /^[a-zA-Z0-9\s,#]+$/g;
    let check = regex.test(value);
    return check;
  };

  renderHiddenFieldText(field) {
    var divClassName = `form-group row`;
    var inputClasses = "col-sm-12 col-sm-offset-0";

    return (
      <div className={divClassName} style={{ display: "none" }}>
        <div className={inputClasses}>
          <input className="form-control" type={field.type} {...field.input} />
        </div>
      </div>
    );
  }

  renderFieldRadio(field) {
    return (
      <div style={{ marginRight: 10 }}>
        <label
          className="custom-container-radio liveqa-label"
          style={{ marginBottom: 5 }}
        >
          {field.label}
          <input {...field.input} type={field.type} />
          <span className="radiomark"></span>
        </label>
      </div>
    );
  }
}
